import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Stack } from '@mui/material'

import { isNative } from '@dhl/webview'

import { Page } from '../components/Page'
import { SignInFooter } from '../components/SignInFooter'
import { useSignInLink } from '~/appLinks'

import { RecoveryForm } from './RecoveryForm'
import { TypographyDark } from '~/components/TypographyDark'

export const RecoveryPage = () => {
  const { t } = useTranslation()
  const [accountEmail, setAccountEmail] = useState<string>()
  const navigate = useNavigate()
  const signInLink = useSignInLink()

  const onBack = () => {
    navigate(signInLink)
  }
  return (
    <Page title={t('account.recoveryPage.titleText')} onBack={isNative() ? onBack : undefined}>
      <Stack spacing={2}>
        <TypographyDark variant="h4" gutterBottom>
          {t('account.recoveryPage.titleText')}
        </TypographyDark>

        {accountEmail && (
          <>
            <TypographyDark gutterBottom data-test="sent-recovery">
              {t('account.recoveryPage.mailSendToText', { email: accountEmail })}
            </TypographyDark>
            <TypographyDark gutterBottom variant="body2">
              {t('account.recoveryPage.itTakesSomeTimeText')}
            </TypographyDark>
          </>
        )}

        {!accountEmail && (
          <>
            <TypographyDark gutterBottom>{t('account.recoveryPage.explanationText')}</TypographyDark>

            <RecoveryForm setAccountEmail={setAccountEmail} />
          </>
        )}

        <Box pt={2} pb={8}>
          <SignInFooter />
        </Box>
      </Stack>
    </Page>
  )
}
